import { getAssetTypeConfig, resolveAssetType } from '@/utils/assetTypeUtils'

/** Fields shown in the Assets list table — search matches any of these. */
export function matchesAssetListSearch(
  vehicle: Record<string, unknown>,
  query: string,
): boolean {
  const q = query.trim().toLowerCase()
  if (!q) return true

  const typeLabel =
    getAssetTypeConfig(resolveAssetType(vehicle, 'car'))?.label ?? 'Car'

  const fields: unknown[] = [
    typeLabel,
    vehicle.vehicleId,
    vehicle.id,
    vehicle.vin,
    vehicle.vehicleIdEncrypted,
    vehicle.make,
    vehicle.car_make,
    vehicle.model,
    vehicle.year,
    vehicle.licensePlate,
    vehicle.number_plate,
    vehicle.color,
    vehicle.colour,
    vehicle.status,
    vehicle.primary_status,
    vehicle.sub_status,
    vehicle.status_label,
    vehicle.asset_type,
    vehicle.vehicle_type,
  ]

  return fields.some((value) => {
    if (value == null || value === '') return false
    return String(value).toLowerCase().includes(q)
  })
}
